import { QueryClient } from '@tanstack/react-query'

/**
 * The app's one query cache.
 *
 * It used to be a const inside `main.tsx`, which was fine while nothing outside the React tree needed it.
 * Switching tenant does (phase 6 step 07): every cached response was fetched as a member of the tenant being
 * left, and React Query would hand those cached answers straight to the new session. So the cache has to be
 * clearable from plain code, which means it has to be importable from plain code.
 *
 * Still a module-level singleton, and still created exactly once — moving it changed where it lives, not how
 * many there are.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
